import { validateProps } from '../utils';
import { isValidBase } from './BaseEntity';
export const isValidMeetingType = meetingType => isValidBase(meetingType) && validateProps(meetingType, ['name', 'calendarTokenId', 'defaultService', 'meetingLinkProvider']);
//# sourceMappingURL=MeetingType.js.map